module.exports = __webpack_public_path__ + "img/search-header-nav-below-cjdr.bc82bc93.png";